import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";

interface NotificationState {
  open: boolean;
  message: string;
  severity?: "success" | "error" | "warning" | "info"; // Optional severity field
}

const initialState: NotificationState = {
  open: false,
  message: "",
  severity: "success", // Default severity is "info"
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotificationOpen: (state, action: PayloadAction<any>) => {
      state.open = action.payload.open;
      state.message = action.payload.message;
      state.severity = action.payload.severity || "success"; 
    },
  },
});

export const { setNotificationOpen } = notificationSlice.actions;

export const selectNotificationOpenStatus = (state: RootState) =>
  state.notification.open;
export const selectNotifcationMessage = (state: RootState) =>
  state.notification.message;
export const selectNotificationSeverity = (state: RootState) =>
  state.notification.severity || "success"; // Default severity is "info"

export default notificationSlice.reducer;
